module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-week-planner"
  }, [_c('div', {
    staticClass: "days-selector"
  }, [_c('p', {
    staticClass: "mx-1"
  }, [_vm._v("shifts number")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shiftCount),
      expression: "shiftCount"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.shiftCount = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.shiftCounts), function(value, key) {
    return _c('option', {
      domProps: {
        "value": value
      }
    }, [_vm._v(_vm._s(key))])
  }), 0), _c('p', {
    staticClass: "mx-1"
  }, [_vm._v("days to show")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.daysToShow),
      expression: "daysToShow"
    }],
    attrs: {
      "type": "number",
      "max": "21"
    },
    domProps: {
      "value": (_vm.daysToShow)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.daysToShow = $event.target.value
      }
    }
  }), _c('p', {
    staticClass: "mx-1"
  }, [_vm._v("hour offset")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hourOffset),
      expression: "hourOffset"
    }],
    attrs: {
      "type": "number",
      "max": "12"
    },
    domProps: {
      "value": (_vm.hourOffset)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.hourOffset = $event.target.value
      }
    }
  })]), _c('EasyWeeksWrapper', {
    attrs: {
      "daysToShow": Number(_vm.daysToShow),
      "autoShift": _vm.shiftCount,
      "hourOffset": _vm.hourOffset
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7293ba41!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backoffice/WeekPlanner.vue
// module id = 2588
// module chunks = 1